"use client";
import React, { useState } from "react";

export default function Accordion({ items }) {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {items.map((item, index) => (
        <div key={index} className="rounded shadow-sm">
          <h3
            className={`text-lg font-bold cursor-pointer flex items-center  space-x-2 px-4 py-4 transition-all rounded-full ${
              openIndex === index ? "bg-brand text-white" : "bg-white text-brand hover:bg-brand hover:text-white"
            }`}
            onClick={() => handleToggle(index)}
          >
              {openIndex === index ? (
                <span className="bg-white text-brandGreen block rounded-full">
                <svg
                  xmlns="https://www..w3.org/2000/svg"
                  className="h-5 rotate-180 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
                </span>
              ) : (
                <span className="bg-brandGreen block rounded-full">
                <svg
                  xmlns="https://www..w3.org/2000/svg"
                  className="h-5 rotate-90 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
                </span>
              )}
          <span>
            {item.title}
          </span>
            {/* Arrow Icon */}
           
          </h3>
          {openIndex === index && (
            <div
              className="text-gray-800 bg-white p-6 md:p-8 text-lg rounded-xl"
              dangerouslySetInnerHTML={{ __html: item.content}}>
            </div>
          )}
        </div>
      ))}
      </>
  );
}
